import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-layout',
  templateUrl: './print-layout.component.html',
  styleUrls: ['./print-layout.component.scss'],
})
export class PrintLayoutComponent implements OnInit, OnDestroy {
  data = new Date();

  private appContainer: HTMLElement | null = null;

  constructor() { }

  ngOnInit(): void {
    this.appContainer = document.querySelector('.app-container');
    if (this.appContainer) {
      this.appContainer.style.overflow = 'auto';
      this.appContainer.style.height = 'auto';
      this.appContainer.style.minHeight = '100vh';
    }
  }

  ngOnDestroy(): void {
    if (this.appContainer) {
      this.appContainer.style.overflow = 'hidden';
      this.appContainer.style.height = '100vh';
      this.appContainer.style.minHeight = '';
    }
  }

}
